import { Component, HostBinding } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { environment as ENV } from '../../../../environments/environment';
declare const window: any;
@Component({
  selector: 'upsc-flex-footer',
  templateUrl: './flex-footer.component.html',
  styleUrls: ['./flex-footer.component.scss']
})
export class FlexFooterComponent {
  @HostBinding('class') public hostClass = 'footer';

  thisYear = (new Date()).getFullYear();
  currentYear: number = new Date().getFullYear();
  techAgreementLink = ENV.links.techAgreement;
  privacyLink = ENV.links.privacyNotice;
  canadaprivacyLink = ENV.links.canadaprivacyNotice;
  canadaproductLink = ENV.links.canadaProductDisclosures;
  //Europe Footer links
  ukComplints = ENV.links.ukComplints;
  ukprivacyNotice = ENV.links.ukprivacyNotice;
  ukproductDisclosures = ENV.links.ukproductDisclosures;

  toggleAccordion(el: string) {
    let accordionItemList = document.querySelectorAll('.accordion-collapse');
    accordionItemList.forEach(element => {
      if (element.id != el)
        element.classList.remove('collapsed');
    });
    let element = document.getElementById(el);
    console.log(element)
    element.classList.toggle('collapsed');
  }
  openConsentPreferences(event: Event): void {
    event.preventDefault();
 
    if (typeof window !== 'undefined' && window.OneTrust?.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay();
      window.scrollTo(0, 0);
    } else {
      console.warn('OneTrust library is not available.');
    }
  }

}
